module.exports = __webpack_public_path__ + "static/media/IMG_1234.1e2866f8.jpg";